// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2KFZd","rootMobile":"styles_rootMobile__1X0FX"};